// extracted by mini-css-extract-plugin
export default {"group-meeting":"styles_group-meeting__P6Cuw","group-meeting__button":"styles_group-meeting__button__WshN9"};